import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import styled from 'styled-components'

import Spacer from '~/components/Spacer'
import FormError from '~/components/Form/ErrorText'
import constants from '~/style/constants'
import InputTitle from './InputTitle'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 2rem;
`

const OuterWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 70px;
  width: 100%;
  box-shadow: 0px 8px 15px 0px rgba(35, 41, 48, 0.15);
  background: white;
  border-radius: 4px;
  border: 1px solid
    ${(props) => (props.error ? props.theme.colors.error : constants.colors.ui.borderGray)};

  @media (max-width: 768px) {
    height: 56px;
    max-width: 100%;
  }

  @media (max-width: 480px) {
    height: 48px;
  }
`

const Input = styled.input`
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-appearance: none;
  padding: 0;
  border: none;
  background: white;
  outline: none;
  height: 35px;
  width: 100%;
  font-family: ${(props) => props.theme.fonts.avenirNextRegular};
  font-size: 1rem;
  color: ${(props) => props.theme.colors.text.input};
  &::placeholder {
    color: ${(props) => props.theme.colors.text.inputPlaceholder};
  }
  caret-color: ${(props) => props.theme.colors.primary};
  text-indent: 20px;
  border-right: ${(props) => (props.borderRight ? '1px solid #D5D8DB' : '0px solid #D5D8DB')};
  border-radius: 0;

  @media (max-width: 768px) {
    height: 30px;
    font-size: 0.9rem;
    max-width: none;
    flex: 1;
  }

  @media (max-width: 480px) {
    height: 28px;
    font-size: 0.85rem;
  }
`

@inject((all) => ({
  validateDisplayMessage: all.store.divorceLookup.validateDisplayMessage,
  firstName: all.store.divorceLookup.firstName,
  middleName: all.store.divorceLookup.middleName,
  lastName: all.store.divorceLookup.lastName,
  changeKey: all.store.divorceLookup.changeKey,
}))
@observer
class FullName extends Component {
  handleChange = ({ target: { name, value } }) => this.props.changeKey(name, value)

  render() {
    const firstNameError = this.props.validateDisplayMessage('firstName')
    const middleNameError = this.props.validateDisplayMessage('middleName')
    const lastNameError = this.props.validateDisplayMessage('lastName')
    const error = firstNameError || middleNameError || lastNameError

    return (
      <Wrapper>
        <InputTitle>
          Full Name
          <Spacer direction="width" mobile={11} desktop={11} />
        </InputTitle>

        <Spacer desktop={16} mobile={4} />
        <OuterWrapper error={error}>
          <Input
            placeholder="First"
            name="firstName"
            borderRight
            value={this.props.firstName}
            onChange={this.handleChange}
          />
          <Input
            placeholder="Middle"
            name="middleName"
            borderRight
            value={this.props.middleName}
            onChange={this.handleChange}
          />
          <Input
            placeholder="Last"
            name="lastName"
            value={this.props.lastName}
            onChange={this.handleChange}
          />
        </OuterWrapper>
        <FormError error={error} />
      </Wrapper>
    )
  }
}

export default FullName
